// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + {"223":"commons","245":"component---src-pages-index-tsx","453":"component---src-pages-404-tsx"}[chunkId] + "-" + {"223":"858da2a0c134835e3701","245":"0554f22a6f9f000a63a1","453":"c2ff7176dda05b16d308"}[chunkId] + ".js";
};